import { API_URL, LOCALSTORAGE_KEY } from "@config";
import { createFetchTransport, createHttpClient } from "@kalodata/http";
import type { ClipHttpEnvelope } from "./types";

type ClipHttpEnvelopeToken = ClipHttpEnvelope<{ accessToken: string | null }>;

const refreshTokenClient = createHttpClient({
  baseUrl: API_URL,
  transport: createFetchTransport(),
  plugins: [],
});

export const requestRefreshAccessToken = async () => {
  const accessToken = localStorage.getItem(LOCALSTORAGE_KEY.ACCESS_TOKEN);
  const response = await refreshTokenClient.request<ClipHttpEnvelopeToken>({
    method: "POST",
    url: "/api/token/refresh",
    credentials: "include",
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });
  return response?.data?.accessToken ?? null;
};
